import * as Sentry from '@sentry/nextjs';
import PropTypes from 'prop-types';

import { TwitterTweetEmbed } from 'react-twitter-embed';

const TweetEmbed = ({ tid }) => {
  return (
    <div className="mb-[15px]">
      <Sentry.ErrorBoundary
        fallback={`An error with Twitter has occurred. View the tweet: https://x.com/placeholder/status/${tid}`}
      >
        <TwitterTweetEmbed tweetId={tid} />
      </Sentry.ErrorBoundary>
    </div>
  );
};

TweetEmbed.propTypes = {
  tid: PropTypes.string.isRequired,
};

export default TweetEmbed;
